<template>
  <div>
    <div
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/chaxun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            货物前移查询
          </span>
          <span class="ml-5">
            查询时间: 从
            <span style="color: red">
              {{ searchForm.DateLessThan | changeDate }}
            </span>
            到
            <span style="color: red">
              {{ searchForm.DateMoreThan | changeDate1 }}
            </span>
          </span>
          <span class="ml-5">
            <span>
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
            <span>
              <span class="ml-3"> 全部金额合计: </span>
              <span class="money">¥{{ totalMoney }}</span>
              <span class="ml-3"> 全部数量合计: </span>
              <span class="totalNum">{{ totalNum }}</span>
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <div class="row ml-2 mb-2 mt-2">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-8">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-6 P-0">
                        <div class="row ml-lg-1 p-0 font">销售日期:</div>
                      </div>
                      <div class="col-lg-6 p-0">
                        <date @changeDate="changeDate1($event)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">到:</div>
                      <div class="col-lg-6 p-0">
                        <date @changeDate="changeDate2($event)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="row ml-lg-3">
                  <button
                    class="bg-primary button_zi hei"
                    style="width: 30%"
                    @click="getClerkGoodsForward()"
                  >
                    查询
                  </button>
                  <button
                    class="ml-lg-2 bg-success button_zi"
                    style="width: 30%"
                    @click="start_print()"
                  >
                    打印
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showPage">
          <table class="table table-striped table-hover" ref="print">
            <thead>
              <tr style="white-space: nowrap">
                <th>药品名称</th>
                <th>产地名称</th>
                <th>规格</th>
                <th>批号</th>
                <th>数量</th>
                <th>单位</th>
                <th>单价</th>
                <th>发票号</th>
                <th>金额</th>
                <th>库区</th>
                <th>记账日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td @dblclick="onInputdrugName(index)">{{ item.drugName }}</td>
                <td @dblclick="onInputcustomerName(index)">
                  {{ item.productFactory }}
                </td>
                <td>{{ item.spec }}</td>
                <td>{{ item.batchNum }}</td>
                <td>{{ item.storeNum }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.price }}</td>
                <td>{{ item.isGoodsForward }}</td>
                <td>{{ item.storeMoney }}</td>
                <td>{{ item.storeNo }}</td>
                <td>{{ item.accountDate | formatUTC }}</td>
              </tr>
            </tbody>
          </table>
          <!-- 分页 -->
          <div>
            <v-pagination
              :total="total"
              :current-page="current"
              @pagechange="pagechange"
            ></v-pagination>
          </div>
          <p class="text-center">
            <img
              src="../../static/images/tuding.png"
              style="width: 1.5rem; height: 1.5rem"
              alt=""
            />
          </p>
        </div>

        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>
      </div>
    </div>

    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
import date from "../components/Date.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      date: new Date(),
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
        DateMoreThan: "",
        DateLessThan: "", // 今天+1
      }, //搜索内容
      totalNum: "",
      totalMoney: "",
      searchData: [], //搜索返回的清单
      isLoading: false,
      showPage: true,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数
    };
  },
  components: {
    vPagination,
    Loading,
    date,
  },
  computed: {},
  filters: {
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    changeDate(date) {
      let change_date =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      return change_date + " 00:00:00";
    },
    changeDate1(date) {
      let time_change =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      let year = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(
          new Date(time_change).getTime() - 24 * 60 * 60 * 1000
        ).getMonth() + 1;

      let time_date = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getDate();

      let time;
      if (month < 10) {
        if (time_date < 10)
          time = year + "-" + "0" + month + "-" + "0" + time_date;
        else {
          time = year + "-" + "0" + month + "-" + time_date;
        }
      } else {
        if (time_date < 10) {
          time = year + "-" + month + "-" + "0" + time_date;
        } else {
          time = year + "-" + month + "-" + time_date;
        }
      }

      let change_date = time;
      return change_date + " 23:59:59";
    },
  },

  methods: {
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },
    //动态绑定时间
    time: function () {
      let nextDate = new Date(this.date.getTime() + 24 * 60 * 60 * 1000);
      let year = nextDate.getFullYear();
      let month = nextDate.getMonth() + 1;
      let time_date = nextDate.getDate();
      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }
      this.searchForm.DateLessThan = time;
    },
    changeDate1: function (date) {
      this.searchForm.DateLessThan = date.replace(/\-/g, "");
      this.searchForm.DateLessThan1 = date;
    },
    changeDate2: function (date) {
      let year = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000).getMonth() + 1;

      let time_date = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getDate();
      // console.log(time_date)
      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }

      this.searchForm.DateMoreThan = time;
      // console.log(time)
      this.searchForm.DateMoreThan1 = date;
    },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc = this.searchData[index].drugName;
      } else {
        this.searchForm.ypmc = this.tableData[index].drugName;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].productFactory;
      } else {
        this.searchForm.cdmc = this.tableData[index].productFactory;
      }
    },

    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDay1(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "" + tMonth + "" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },

    getClerkGoodsForward: async function (PageIndex) {
      //获取三个月前的时间戳   时间条件适合才可以查询
      const that = this;
      let threeMonth = that.getDay(-3 * 30);

      let threeMonthTime = new Date(threeMonth).getTime();

      let today = that.getDay(0);
      let todayTime = new Date(today).getTime();

      let select = that.searchForm.DateLessThan1;
      //  console.log(select)
      let select1 = that.searchForm.DateMoreThan1;
      let seTime = new Date(select).getTime();

      let seTime2 = new Date(select1).getTime();

      let ces = that.searchForm.DateLessThan;
      let a = ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
      // console.log(a)
      let ces1 = that.searchForm.DateMoreThan;
      let b =
        ces1.slice(0, 4) + "-" + ces1.slice(4, 6) + "-" + ces1.slice(6, 9);
      // console.log(b)
      let cesTime = new Date(a).getTime();
      // console.log(cesTime)
      let cesTime2 = new Date(b).getTime();
      // console.log(cesTime2)
      if (cesTime >= cesTime2) {
        alert("开始日期要小于结束日期");
      } else {
        if (
          threeMonthTime <= seTime &&
          seTime <= todayTime &&
          threeMonthTime <= seTime2 &&
          seTime2 <= todayTime
        ) {
          that.isLoading = true;
          if (!PageIndex) {
            PageIndex = 1;
          }
          that.PageNo = PageIndex || that.PageNo;
          const { data: res } = await this.$http.post("Dls/getFun", {
            action: "ClerkGoodsForward",
            obj: JSON.stringify({
              PageIndex,
              PageSize: 20,
              DrugName: that.searchForm.ypmc.trim(),
              BatchNum: that.searchForm.ph.trim(),
              ProductFactory: that.searchForm.cdmc.trim(),
              Spec: that.searchForm.gg.trim(),
              DateMoreThan: that.searchForm.DateLessThan, // 销售日期不小于
              DateLessThan: that.searchForm.DateMoreThan, // 销售日期不大于
            }),
          });

          // console.log(res)
          if (res.isok) {
            const obj = res.data;

            that.tableData = obj.rows;
            if (that.tableData.length > 0) {
              that.showPage = true;
            } else {
              that.showPage = false;
            }
            that.Pcount = obj.pcount;
            that.Record = obj.record;
            that.total = obj.record;
            that.totalMoney = obj.totalMoney;
            that.totalNum = obj.totalNum;
            that.isLoading = false;
          }
        } else {
          alert("请选择三个月以内的时间进行查询,查询日期不大于当天");
        }
      }
    },

    pagechange: function (currentPage) {
      this.getClerkGoodsForward(currentPage);
    },

    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    //this.time();
    this.searchForm.DateMoreThan = this.getDay1(1);
    this.searchForm.DateLessThan = this.getDay1(0);
    this.searchForm.DateLessThan1 = this.getDay(-1);
    this.searchForm.DateMoreThan1 = this.getDay(0);
    this.getClerkGoodsForward();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.hei {
  height: 1.5rem;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.money {
  color: red;
  font-weight: 500;
}
.span_close:hover {
  color: #3190e8;
}
.totalNum {
  color: green;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/GoodsForward.vue